<script>
  import Wysiwyg from '$lib/default/Wysiwyg.svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let details;
  export let featuredImage;
  export let content1;
  export let content2;

  let grow = false;
</script>

<section
  class="details"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <div class="details__top">
    <div class="details__image">
      {#if featuredImage}
        <img
          src={featuredImage.src}
          alt={featuredImage.alt}
          height={featuredImage.height}
          width={featuredImage.width}
        />
      {/if}
    </div>
    <div class="details__featured-text-block">
      <img
        class="details__featured-stripes"
        src={details.featuredStripes}
        alt="Two stripes"
      />
      <h5 class="details__featured-text">{details.featuredText}</h5>
    </div>
  </div>
  <Wysiwyg content={content1} />

  <div class="details__main">
    <!-- {details.content} -->
    {#each details.items as item}
      <div class="details__item">
        <h6>{item.title}</h6>
        <ul>
          {#each item.listItems as listItem}
            <li>
              {listItem}
            </li>
          {/each}
        </ul>
      </div>
    {/each}
  </div>
  <Wysiwyg content={content2} />
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .details {
    padding: 0;

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    &__top {
      display: flex;
      gap: 9.7rem;
      padding-bottom: 5rem;
      border-bottom: solid 1px $light-border;

      @include resp-max('m') {
        gap: 7rem;
      }

      @include resp-max('s') {
        flex-direction: column;
        gap: 3rem;
        margin-bottom: 5rem;
      }
    }

    &__image {
      width: 35rem;
      height: 35rem;
      aspect-ratio: 1;
      background-color: var(--royal-light);

      @include resp-range('s', 'm') {
        width: 33rem;
        height: 33rem;
      }

      @include resp-max('s') {
        aspect-ratio: 1;
        width: 100%;
      }

      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }
    }

    &__featured {
      &-text-block {
        padding-top: 3.8rem;
        display: flex;
        flex-direction: column;
        gap: 3rem;

        @include resp-max('m') {
          padding-top: 3.2rem;
        }

        @include resp-max('s') {
          flex-direction: row;
          padding-top: 0;
          gap: 3rem;
        }

        h5 {
          @include resp-range('s', 'm') {
            font-size: 1.7rem;
          }

          @include resp-max('s') {
            font-size: 2rem;
            line-height: 1.44;
          }
        }
      }

      &-stripes {
        width: 2.088rem;
        height: 4rem;

        @include resp-max('s') {
          margin-top: 0.8rem;
        }
      }
    }

    &__main {
      padding-top: 5rem;
      column-count: 2;
      column-gap: 5rem;

      @include resp-max('m') {
        column-count: 1;
      }
    }

    &__item {
      margin-bottom: 3rem;

      h6:first-child {
        margin-top: 0;
      }

      ul {
        margin-top: 2rem;
      }

      li {
        color: var(--royal-light);
        font-size: 1.75rem;
        line-height: 1.6;
        margin-left: 3.5rem;
        position: relative;

        &:not(:first-child) {
          margin-top: 1.5rem;
        }

        &::before {
          left: -3.5rem;
          content: '';
          border-bottom: 1.5px solid var(--aqua-1);
          width: 1.9rem;
          position: absolute;
          top: 1.15rem;
        }
      }
    }
  }
</style>
